import { gql } from '@apollo/client'

const SEARCH_PATIENT_TAGS = gql`
  query SEARCH_PATIENT_TAGS($searchTerm: String) {
    searchPatientTags(searchTerm: $searchTerm) {
      id
      name
      color
      icon
    }
  }
`

export default SEARCH_PATIENT_TAGS
